import styled from "styled-components";

export const MyFollowedBidsStyled = styled.div<{
  widthProgress?: any;
}>`
  .my_active_bids_sec {
    margin-top: 25px;
  }
  .my-no-active-bids {
    margin-top: 100px;
    margin-bottom: 50px;
    font-size: 24px;
    text-align: center;
  }
`;
